module.exports = __webpack_public_path__ + "img/ads2.3581dfd3.png";